import React, { useState,useEffect } from 'react';

import '../../Assets/css/custom.css';
import '../../Assets/css/w3-css.css';
import {Link} from 'react-router-dom';
import {Redirect} from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import Header from '../../Common/Header';
import Modal from 'react-bootstrap/Modal';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css"; 

import SuccessMsg from '../../Common/SuccessMsg';
import CommonAPI2 from '../../Common/FD_BILL_APIs';
import CommonAPI from '../../Common/CommonAPI';
import moment from 'moment';
import FadeLoader from "react-spinners/HashLoader"; 
import BillMaintainPage from "./BillMaintain"

function  ActiveBillPaymentDetails (props)  {    

    var BillId = JSON.parse(sessionStorage.getItem("BillValues")).BillRef;
    var Billrefz = JSON.parse(sessionStorage.getItem("BillValues")).BillReference;     

     const [MainCustomerName,setMainCustomerName] = useState();
     const [SuccessLoading,setSuccessLoading] = useState(true);
     const [BillList,setBillList] = useState([]);
     const [BillRef,setBillRef] = useState("");
     const [dueDate,setdueDate] = useState("");
     const [Provider,setProvider] = useState("");
     const [BillNUmber,setBillNUmber] = useState("");
     const [PayStart,setPayStart] = useState("");
     const [PayEnd,setPayEnd] = useState("");
     const [PayByAccount,setPayByAccount] = useState("");
     const [BillingAccount,setBillingAccount] = useState("");
     const [PayAmount,setPayAmount] = useState("");
     const [BillFrequency,setBillFrequency] = useState("");
     const [BeneReference,setBeneReference] = useState("");
     const [YourReference,setYourReference] = useState("");
     const [SuccessMSG,setSuccessMSG] = useState(false);
     const [CancelPayment,setCancelPayment] = useState(false);
     const [EnteredPassword,setEnteredPassword] = useState("");
     const [ErrorMSG,setErrorMSG] = useState("");
     const [EditBill,setEditBill] = useState(false);
     
     useEffect( () => {
        GetBillDetailsAPI();        
      },[]);
      const GetBillDetailsAPI = () =>{
        CommonAPI2. ActiveBillDetails({BillId:BillId},(result) =>{   
            if(result){                    
                setBillList(result.billPayments);
                setBillRef(result.id);
                setdueDate(result.dueDateMilli);
                setProvider( result.provider);
                setBillNUmber( result.billNo);
                setPayStart( result.startDate);
                setPayEnd( result.endDate);
                setPayByAccount(result.accountNo);
                setBillingAccount( result.billingAccount);
                setPayAmount(result.payAmount);
                setBillFrequency( result.frequency);
                setBeneReference(result.beneReference);
                setYourReference(result.bankReference);               
              setSuccessLoading(false);
            } 
            if(result.message){
                console.log("Invalid Request!");
                setSuccessLoading(false);
            }          
        });
      }
     const ResponseLoadingModal = () => {
        return(
            <Modal
            size="lg"
            centered 
            className="loading1" show={SuccessLoading}>          
                  <FadeLoader
                  height={25}
                  width={5}
                  radius={2}
                  margin={2}
                  color={"#197b55"}
                  size={"80px"} this also works
                  loading={SuccessLoading}
                />       
           </Modal>
         )
      }

      const BillMaintainToggleModal = () => {
        setEditBill(!EditBill) ; 
        GetBillDetailsAPI();
       }

       const CheckFirstPassword = () =>{ 
        CommonAPI.CheckPassword({password:EnteredPassword},(results) =>{ 
         if(results.password==="true"){
             setErrorMSG();
             StopBillAPI();
         }else{
             setErrorMSG("Enter Correct Password");
         }
        })    
     }

     const StopBillAPI =()=>{
        setSuccessLoading(true);
        CommonAPI2.SuspendBill({BillId: BillId,BillPassword:EnteredPassword},(results) =>{ 
            if(results.status==='SUCCESS'){
                setSuccessLoading(false);
                setSuccessMSG(true);
                setErrorMSG();
            }if(results.status==='UNSUCCESS'){
                setSuccessLoading(false);
                setErrorMSG("Your Bill Cancel Unsuccess");
            }else{
                setSuccessLoading(false);
                setErrorMSG("Serverside Error Found");
            }
           }) 
     }

      if(SuccessLoading){
        return ( <div>{ResponseLoadingModal()}</div> );
      }else if(EditBill){        
        return( <BillMaintainPage isOpen={EditBill} toggle={BillMaintainToggleModal} 
           />)
      }else if(SuccessMSG){
        return(
        <SuccessMsg ConfirmSuccess={SuccessMSG} 
        Close={props.toggle} head="SUCCESSFULLY" head2="CANCELLED" 
        contentline1="Your Bill Payment Cancelled Successfully"
         />
         )
    }
        return (
            <Modal
              show={props.isOpen}
              size="xl"
              aria-labelledby="contained-modal-title-vcenter"
              centered 
              backdrop="static"
              onHide={props.toggle}
            >
              <Modal.Header closeButton>
                <Modal.Title className='hselect' id="contained-modal-title-vcenter">
                  <p className='modal-head-f'>BILL PAYMENT</p><br/>DETAILS
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
              <Row   className='div-background d-flex align-items-start'>                    
                    <Col lg={3}>
                        <div>                           
                            <p className='p-line2'>Reference Number</p>
                            <p className='p-line'>{Billrefz}</p> 
                            <p className='p-line2 m-top'>Service Provider</p>
                            <p className='p-line'>{Provider}</p>                                
                        </div>
                   </Col>
                    <Col lg={3} className="pawn-list">
                        <div>
                            <p className='p-line2'>Payment By Account</p>
                            <p className='p-line'>{PayByAccount}</p>
                            <p className='p-line2 m-top'>Billing Account</p>
                            <p className='p-line'>{BillingAccount}</p>
                        </div>
                   </Col>
                    
                    <Col lg={2} className="pawn-list">
                        
                        <div>
                            <p className='p-line2'>BENEFICIARY REFERENCE</p>
                            <p className='p-line '>{BeneReference?BeneReference:"-"} </p>
                            <p className='p-line2 m-top'>YOUR REFERENCE</p>
                            <p className='p-line'>{YourReference?YourReference:"-"}</p>
                        </div>
                        
                   </Col>
                   <Col lg={2} className="pawn-list">
                    {BillFrequency?
                        <div>
                            <p className='p-line2 t-right'>Payment Start</p>
                            <p className='p-line t-right'>{PayStart?moment(PayStart).format('DD/MM/YYYY'):"-"} </p>
                            <p className='p-line2 m-top t-right'>Payment End</p>
                            <p className='p-line t-right'>{PayEnd?moment(PayEnd).format('DD/MM/YYYY'):"U.F.N"}</p>
                            <p className='p-line m-top t-right'></p>
                        </div>  
                        :
                        <div>
                            <p className='p-line t-right'>Payment On</p>
                            <p className='p-line2 t-right'>{PayStart?moment(PayStart).format('DD/MM/YYYY'):"-"} </p>
                        </div>
                        }                     
                   </Col>
                    <Col lg={2} className="pawn-list">
                       <div className='d-flex flex-column align-items-end justify-content-end'>  
                            <p className='p-box2 t-center'>
                            {BillFrequency==="D"?"Daily":BillFrequency==="W"?"Weekly"
                             :BillFrequency==="M"?"Monthly":BillFrequency==="Q"?"Quarterly"
                             :BillFrequency==="H"?"Half Yearly":BillFrequency==="Y"?"Yearly":"-"
                             }
                            </p>                           
                            <p className='p-line2 t-center'>LKR {parseFloat(PayAmount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</p> 
                            <div className='d-flex flex-row align-items-end justify-content-end'> 
                             <Button  onClick={()=>setEditBill(true)} className='btn-amend'>Amend</Button> 
                             <Button onClick={()=>setCancelPayment(true)}  className='btn-amend btn-right'>Cancel</Button> 
                            </div>   
                        </div>
                   </Col>                   
                </Row>
                {CancelPayment?
                <Row>
                    <Form >
                    <Form.Group as={Row} className="mb-1">
                        <Col lg={4}>
                        <Form.Label className="c-font t-right">
                            Password to Confirm Stop of Further Payments
                        </Form.Label>
                        </Col>
                        <Col lg={3}>
                        <Form.Control 
                            value = {EnteredPassword}                       
                            onChange={(text)=>setEnteredPassword(text.target.value)} 
                            className=" form-h2" size="sm" maxLength={8} type="password" 
                            placeholder="PASSWORD" />
                        </Col>
                        <Col lg={5} className="d-flex justify-content-start std-confirm">
                        <Button
                            onClick={()=>CheckFirstPassword()}                                                    
                            className='btn-logout' 
                            variant="primary" type="submit">
                            CONFIRM
                        </Button>
                        </Col>
                    </Form.Group>
                    <p className='vali-txt'>{ErrorMSG}</p> 
                    </Form>
                </Row>
                :null
                }
                {BillList.length?
                <Table   className='block-top' hover responsive>
                    <thead >
                        <tr>
                        <th className='td-width3'>No</th>
                        <th className='td-width3'>Paid On</th>
                        <th className='td-width3'>Amount Rs</th>                           
                        <th className='td-width3'>Pay Status</th>                           
                        </tr>
                    </thead>
                    <tbody>
                    {BillList.length?BillList.map(( listValue, index ) => {
                       return( 
                        <tr  >
                        <td className='td-width3'>
                            <p className='tb-text m-top'>{index+1}.</p>
                        </td>                       
                        <td className='td-width3'>
                            <p className='tb-text m-top'>{listValue.paidOn?moment(listValue.paidOn).format('DD/MM/YYYY'):"-"}</p>
                        </td>
                        <td className='td-width3'>
                            <p className='tb-text m-top'>{listValue.amount.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                        </td>
                        <td className='td-width3'>
                            <p className='tb-text m-top'>{listValue.payStatus=="A"?"Success":listValue.payStatus=="S"?"Suspend":listValue.payStatus=="R"?"Reject":null}</p>
                        </td>                             
                        </tr>
                       )
                        }):
                        <Row className='tablebody'>
                            <p className='h-text block-top'>No Records</p>
                        </Row>
                } 
                    </tbody>
                </Table>
                :null
                }
              </Modal.Body>
              
            </Modal>
          );
    }

export default ActiveBillPaymentDetails;